import Termite from '@divtel/termite';
import Fader from '@Shared/Fader';
import React from 'react';
import { Container as Grid } from 'react-bootstrap';
import ForgotPasswordError from './Error';
import ForgotPasswordForm from './Form';
import ForgotPasswordSuccess from './Success';

const ForgotPassword: React.FC = () => {

  return (
    // @ts-ignore
    <Termite app='Forgot Password' noSession>
      <div className='main-section'>
        <Fader>
          <Grid style={{ paddingTop: 44 }}>

            <ForgotPasswordError />
            <ForgotPasswordSuccess />
            <ForgotPasswordForm />

          </Grid>
        </Fader>
      </div>
    </Termite>
  );
}

export default ForgotPassword;